/* eslint-disable */
// @ts-nocheck

import { getTaskFeedTemplate } from './taskFeedTemplate';
import ability from '../abilities/ability';

export function initToolbar(translate) {
	window.bynder = window.bynder || {};

	const refreshIconSvg = `
		<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="16px" height="16px" aria-hidden="true" style="vertical-align: middle;">
			<path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35Z"></path>
		</svg>
	`;

	const bynder = window.bynder;
	const is = window.is;
	const _ = window._;

	// Check the namespace
	bynder.helpers = bynder.helpers || {};

	bynder.helpers.ToolbarHelper = (function () {
		// Private fields
		let activeTasks = [];
		let activeDownloads = [];
		// Private methods

		const _initTaskFeed = function () {
			const el = document.getElementById('taskFeed');
			if (!el) return;

			el.addEventListener('click', function () {
				if (!el.classList.contains('active')) {
					el.classList.add('active');
					const dropdown = el.querySelector('.activity-dropdown.tasks');
					const holder = document.getElementById('task-list');
					holder.innerHTML = '';

					if (!dropdown.querySelector('.dropdown-loader')) {
						const loader = document.createElement('div');
						loader.className = 'dropdown-loader';
						loader.innerHTML = refreshIconSvg;
						dropdown.appendChild(loader);
					}

					fetch('/user/tasks/')
						.then((response) => response.json())
						.then((response) => {
							if (dropdown.querySelector('.dropdown-loader')) {
								dropdown.querySelector('.dropdown-loader').remove();
							}
							const compiledTaskFeedTemplate = _.template(
								getTaskFeedTemplate(translate),
							);
							holder.innerHTML = compiledTaskFeedTemplate({
								response,
								canAudit: ability.can('show', 'task_external_upload_audit'),
							});

							const item = holder.querySelector('.task-dropdown-item:last-child');
							const url = '/user/tasks/';
							_initTasks();
							_initPager(
								dropdown,
								response.totalPages,
								holder,
								item,
								url,
								response.pagesLimit,
							);
							_initDownload();
						});

					document.addEventListener('click', function clickOutside(event) {
						if (!el.contains(event.target)) {
							el.classList.remove('active');
							document.removeEventListener('click', clickOutside);
						}
					});

					el.closest('.admin-right')
						.querySelector('.admin-options')
						.addEventListener(
							'mouseenter',
							function () {
								el.classList.remove('active');
							},
							{ once: true },
						);
				} else {
					el.classList.remove('active');
				}
			});
		};

		const _initFeedCount = function () {
			const taskFeed = document.getElementById('taskFeed');
			if (!taskFeed) return;

			fetch('/user/updateFeeds/?count=true')
				.then((response) => response.json())
				.then((returnData) => {
					document
						.querySelectorAll(
							'#activityFeed .admin-dropdown span, #taskFeed .admin-dropdown span',
						)
						.forEach((span) => span.remove());

					if (returnData.newActivityCount) {
						const span = document.createElement('span');
						span.textContent = returnData.newActivityCount;
						document.querySelector('#activityFeed .admin-dropdown').appendChild(span);
					}

					if (returnData.newTaskCount) {
						const span = document.createElement('span');
						span.textContent =
							returnData.newTaskCount > 99 ? '99+' : returnData.newTaskCount;
						document.querySelector('#taskFeed .admin-dropdown').appendChild(span);
					}
				});

			return false;
		};

		const _initPoller = function () {
			const taskFeed = document.getElementById('taskFeed');
			const notificationsNav = document.querySelector('.notifications-nav');
			if (taskFeed || notificationsNav) {
				fetch('/user/getactivetasks/')
					.then((response) => response.json())
					.then((returnData) => {
						if (is.set(returnData.generic)) {
							activeTasks = returnData.generic;
						}

						if (is.set(returnData.downloads)) {
							activeDownloads = returnData.downloads;
						}

						const allTasks = activeTasks.concat(activeDownloads);

						if (allTasks.length > 0) {
							_updateDownloadNotification();

							for (const allTask of allTasks) {
								const t = 2000;
								const c = 0;
								_poller(allTask, t, c);
							}
						}
					});
			}

			return false;
		};

		/* .active-downloads is only part of the ColdFusion footer for now, so this
		 * function will have no effect on Pybynder pages. */
		const _updateDownloadNotification = function () {
			const allTasks = activeTasks.concat(activeDownloads);

			const activeDownloadsElement = document.querySelector('.active-downloads');
			if (!activeDownloadsElement) return;

			if (allTasks.length === 0) {
				activeDownloadsElement.style.display = 'none';
				return;
			}

			activeDownloadsElement.style.display = 'block';
			activeDownloadsElement.querySelector('span.download-count').textContent =
				allTasks.length;

			let progressDescription = '';

			if (activeTasks.length > 0 && activeDownloads.length > 0) {
				progressDescription = translate('downloadtask.progress');
			} else if (activeTasks.length > 0) {
				progressDescription = translate('task.progress');
			} else {
				progressDescription = translate('download.progress');
			}

			activeDownloadsElement.querySelector('span.progress-description').textContent =
				progressDescription;
		};

		const _poller = function (hash, t, c) {
			bynder.helpers.DownloadHelper.pollDownload(hash, function (response) {
				if (!response || response.status == 2 || response.status == 1) {
					let index = activeTasks.indexOf(hash);

					if (index != -1) {
						activeTasks.splice(index, 1);
					} else {
						index = activeDownloads.indexOf(hash);
						activeDownloads.splice(index, 1);
					}

					if (response.status == 1) {
						// add notification in task feed
						_initFeedCount();
						document.getElementById('taskFeed').click();
					}

					_updateDownloadNotification();
				} else if (response.status === 3) {
					// this means the user's session was expired and should log the user out
					bynder.helpers.DownloadHelper.expireSession();
				} else {
					if (c % 10 == 0 && t <= 10000) {
						// every 10xt seconds t is added with a seconde with a max of 10 seconds
						t += 1000;
					}

					c++;
					setTimeout(function () {
						_poller(hash, t, c);
					}, t);
				}
			});
		};

		const _initTasks = function () {
			document.querySelectorAll('.remove-task').forEach((task) => {
				task.removeEventListener('click', removeTaskHandler);
				task.addEventListener('click', removeTaskHandler);
			});

			function removeTaskHandler(e) {
				e.stopPropagation();
				const self = e.currentTarget;
				const id = self.dataset.id;
				fetch('/Download/removeTask/', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ id }),
				})
					.then((response) => response.json())
					.then((response) => {
						if (!response || response.success == false) {
							return false;
						}

						_initFeedCount();
						self.closest('.task-dropdown-item').remove();
					});
			}

			return false;
		};

		const _initDownload = function () {
			const taskList = document.getElementById('task-list');
			if (taskList) {
				document.querySelectorAll('.download-task').forEach((task) => {
					task.removeEventListener('click', downloadTaskHandler);
					task.addEventListener('click', downloadTaskHandler);
				});

				function downloadTaskHandler() {
					const self = this;
					const id = self.dataset.id;
					fetch('/Download/downloadTask/', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({ id }),
					})
						.then((response) => response.json())
						.then((response) => {
							if (!response || response.success == false) {
								return false;
							}

							// recount
							bynder.helpers.DownloadHelper.offerDownload(
								'task',
								response,
								response.hash,
							);
							_initFeedCount();
							self.closest('li.task-dropdown-item').classList.remove('new-task');
						});
				}
			}

			return false;
		};

		const _initPager = function (dropdown, totalPages, holder, item, url, numPerPage) {
			let pagerBorder = 0;
			const setPagerBorder = function () {
				if (item) {
					pagerBorder = holder.offsetHeight - dropdown.offsetHeight * 0.98;
				}
			};
			const loader = document.createElement('div');
			loader.className = 'dropdown-loader';
			loader.style.textAlign = 'center';
			loader.innerHTML = getRefreshIconHtml();
			const pager = (function () {
				const self = {};
				let pageIndex = 1;
				let loading = false;
				self.loadNext = function () {
					if (!pagerBorder) return false;

					if (loading || pageIndex >= totalPages) return false;

					loading = true;
					pageIndex++;
					pagerBorder = 0;
					dropdown.appendChild(loader);
					fetch(`${url}?page=${pageIndex}&numPerPage=${numPerPage}`)
						.then((response) => response.json())
						.then((response) => {
							dropdown.removeChild(loader);
							const compiledTaskFeedTemplate = _.template(
								getTaskFeedTemplate(translate),
							);
							holder.innerHTML += compiledTaskFeedTemplate({
								response,
								canAudit: ability.can('show', 'task_external_upload_audit'),
							});
							setPagerBorder();
							_initDownload();
							_initTasks();
						});

					loading = false;
				};

				return self;
			})();

			setPagerBorder();
			dropdown.removeEventListener('scroll', scrollHandler);
			dropdown.addEventListener('scroll', scrollHandler);

			function scrollHandler() {
				const scrollTop = dropdown.scrollTop;

				if (scrollTop > pagerBorder) {
					pager.loadNext();
				}
			}
		};

		const _initScrollMenu = function () {
			const topMenu = document.querySelector('header.base');
			const filterbar = document.querySelector('.filterbar');
			const singleCollection = document.getElementById('single-collection-top');
			const sidebar = document.querySelector('div.sidebar-left');
			let prevScroll = 0;
			let set = true;
			let show;
			const wFFilterContainer = document.querySelector('.wf-filter-container');

			document.addEventListener('scroll', function () {
				const windowScrollTop = window.scrollY;

				if (windowScrollTop > 50 && windowScrollTop > prevScroll) {
					if (show) {
						clearTimeout(show);
						set = true;
					}

					if (!topMenu.classList.contains('no-small')) {
						topMenu.classList.add('small');
					}

					if (wFFilterContainer) {
						wFFilterContainer.classList.add('filter-sticky');
					}
					if (sidebar) {
						sidebar.classList.add('small');
					}
					if (singleCollection) {
						singleCollection.classList.add('small');
					}

					if (filterbar) {
						filterbar.classList.add('small');
					}
				} else if (windowScrollTop < prevScroll) {
					if (set === true) {
						set = false;
						show = setTimeout(function () {
							topMenu.classList.remove('small');
							if (sidebar) {
								sidebar.classList.remove('small');
							}
							if (wFFilterContainer) {
								wFFilterContainer.classList.remove('filter-sticky');
							}
							if (singleCollection) {
								singleCollection.classList.remove('small');
							}
							if (filterbar) {
								filterbar.classList.remove('small');
							}

							set = true;
						}, 500);
					}
				}

				prevScroll = windowScrollTop;
			});

			if (sidebar) {
				sidebar.querySelector('.toggle-sidebar').addEventListener('click', function () {
					this.querySelector('i').classList.toggle('fa-chevron-left');
					this.querySelector('i').classList.toggle('fa-chevron-right');
					document.body.classList.toggle('sidebar-collapsed');
					fetch('/pysettings/ui', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							sidebar_collapsed:
								document.body.classList.contains('sidebar-collapsed'),
						}),
					}).then(() => {
						sidebar.dispatchEvent(new Event('mouseleave'));
					});
				});

				sidebar.addEventListener('mouseenter', function () {
					this.dataset.collapsed = false;
				});

				sidebar.addEventListener('mouseleave', function () {
					this.dataset.collapsed = true;
				});

				sidebar.addEventListener('mousemove', function () {
					this.dataset.collapsed = false;
				});
			}
		};

		// The element .export-pdf is not part of the header, only the toolbar.
		const _initContactSheetExportBtn = function () {
			const el = document.querySelector('header .tool-bar .export-pdf');
			if (!el) return;

			el.addEventListener('click', function (e) {
				e.preventDefault();

				if (el.classList.contains('loading')) {
					return;
				}

				el.classList.add('loading');
				el.querySelector('.progress').textContent = '0%';
				const loadMore = function () {
					document.querySelector('.loadMore').click();
					document
						.querySelector('.loadMore')
						.addEventListener('click', function (clickedEl, pageLoaded, totalPages) {
							if (!is.set(clickedEl)) {
								el.classList.remove('loading');
								window.print();
								return;
							}

							if (
								is.number(pageLoaded) &&
								is.number(totalPages) &&
								pageLoaded < totalPages
							) {
								el.querySelector('.progress').textContent =
									Math.round((pageLoaded / totalPages) * 100) + '%';
								loadMore();
								return;
							}

							const $images = clickedEl.querySelectorAll('img');
							let imagesLoaded = 0;
							$images.forEach((img) => {
								img.addEventListener('load', imageLoadHandler);
								img.addEventListener('error', imageLoadHandler);
							});

							function imageLoadHandler() {
								imagesLoaded++;
								if ($images.length > imagesLoaded) {
									return;
								}

								el.classList.remove('loading');
								window.print();
							}
						});
				};
				loadMore();
			});
		};

		/* The element #exportToCSV is not part of the header, only the toolbar. We
		 * do not need to worry about MessageBox, therefore, as this event will
		 * only happen on ColdFusion pages. */
		const _initCSVExport = function () {
			const csvExport = document.querySelector('li.exportUsers #exportToCSV');
			if (!csvExport) return;

			csvExport.addEventListener('click', function (e) {
				e.preventDefault();
				fetch('/insights/export/users/', {
					method: 'POST',
				})
					.then((response) => response.json())
					.then((response) => {
						if (!response || response.success == false) {
							bynder.modules.MessageBox.open('error', response.message, 5000);
						} else {
							bynder.modules.MessageBox.open('info', response.message, 5000);
						}
					});
			});
		};

		// Public fields and methods
		return {
			initialize() {
				_initTaskFeed();
				_initFeedCount();
				_initPoller();
				_initScrollMenu();
				_initContactSheetExportBtn();
				_initCSVExport();
			},
			updateFeedCount() {
				_initFeedCount();
			},
			initTaskPoller() {
				_initPoller();
			},
		};
	})();

	if (['complete', 'interactive'].includes(document.readyState)) {
		// if document is already loaded and parsed, run directly else add event listener
		bynder.helpers.ToolbarHelper.initialize();
	} else {
		document.addEventListener('DOMContentLoaded', function () {
			bynder.helpers.ToolbarHelper.initialize();
		});
	}
}
